// extracted by mini-css-extract-plugin
export default {"title":"veXCc_B9CZUNMoZgByy4"};